import Layout from "@/layout/Layout.vue";

/**
 * Documentation — guides d'utilisation.
 *
 * Aucune permission sur la route : l'écran est ouvert à tout compte
 * authentifié, y compris extranet. Ce sont les fiches qui portent les droits,
 * et le filtrage est fait côté serveur (voir GuideCatalog côté backend) : la
 * liste ne contient que ce que le compte a le droit de lire.
 */
const documentationRoutes = {
    path: "/documentation",
    component: Layout,
    meta: {
        title: "Documentation",
        icon: "mdi:book-open-page-variant-outline"
    },
    children: [
        {
            path: "",
            name: "documentation",
            component: () => import("@/views/documentation/DocumentationPage.vue"),
            meta: {
                title: "Documentation",
                icon: "mdi:book-open-page-variant-outline",
                noCache: true,
                // Même instance que la fiche : ouvrir un guide ne doit recharger
                // que le volet de droite, pas l'écran entier (voir AppMain).
                viewKey: "documentation"
            }
        },
        {
            path: ":slug([a-z0-9-]+)",
            name: "documentation-guide",
            component: () => import("@/views/documentation/DocumentationPage.vue"),
            meta: {
                title: "Documentation",
                noCache: true,
                activeMenu: "/documentation",
                viewKey: "documentation"
            },
            hidden: true
        }
    ]
};

export default documentationRoutes;
